import React from 'react';

import Table from '../../../../components/Table';
import Header from '../../../../components/Table/Header';
import Cell from '../../../../components/Cell';

import { I18n } from 'react-redux-i18n';

class KeyIndicatorsNegociantsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: []
    };
  }

  handleSort(id) {
    let { sorted } = this.state;
    let desc = true;
    if (sorted.length > 0 && sorted[0].id === id) {
      desc = !sorted[0].desc;
    }
    sorted = [{ id, desc }];
    this.setState({ sorted, expanded: {} });
  }

  render() {
    const { data } = this.props;
    const columns = [
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.negociantName'
            )}
            styles={`justify-content:flex-start;padding-left:30px`}
            sortable={true}
            sort={() => this.handleSort('negociant_name')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb; justify-content:flex-start;padding-left:30px;font-weight: 600;`}
          />
        ),
        minWidth: 200,
        accessor: 'negociant_name',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.negociantName'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75'
            )}
            sortable={true}
            sort={() => this.handleSort('quantity_eq_75')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            font="sfcompact_text"
            styles={`border-right: 1px solid #e8e9eb`}
          >
            {props.value}
          </Cell>
        ),
        accessor: 'quantity_eq_75',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75OverPoolPct'
            )}
          />
        ),
        Cell: (props) => (
          <Cell {...props} styles={`border-right: 1px solid #e8e9eb`}>
            {props.value}
          </Cell>
        ),
        accessor: 'quantity_eq_75_over_pool_pct',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75OverPoolPct'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.negociantRank'
            )}
            sortable={true}
            sort={() => this.handleSort('negociant_rank')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            font="sfcompact_text"
            styles={`border-right: 1px solid #e8e9eb`}
          >
            {props.value}
          </Cell>
        ),
        accessor: 'negociant_rank',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.negociantRank'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75n1'
            )}
            sortable={true}
            sort={() => this.handleSort('quantity_eq_75_n1')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'quantity_eq_75_n1',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75n1'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75OverPoolPctN1'
            )}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'quantity_eq_75_over_pool_pct_n1',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75OverPoolPctN1'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.negociantRankN1'
            )}
            sortable={true}
            sort={() => this.handleSort('negociant_rank_n1')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'negociant_rank_n1',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.negociantRankN1'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75OverAllocationPct'
            )}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'quantity_eq_75_over_allocation_pct',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.quantityEq75OverAllocationPct'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.nbCustomers'
            )}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'nb_customers',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.nbCustomers'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.customerExclusivityPct'
            )}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'customer_exclusivity_pct',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.customerExclusivityPct'
        )
      },
      {
        Header: () => (
          <Header
            title={I18n.t(
              'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.customerRecurringPct'
            )}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            value={props.value}
            styles={`border-right: 1px solid #e8e9eb`}
          />
        ),

        accessor: 'customer_recurring_pct',
        name: I18n.t(
          'negoce.pilotage_interne.keyIndicatorsNegociants.table.columns.customerRecurringPct'
        )
      }
    ].filter((item) => item !== false);

    const { sorted } = this.state;

    return <Table columns={columns} data={data} expanded sorted={sorted} />;
  }
}

export default KeyIndicatorsNegociantsTable;
